import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'
import type { AxiosInstance } from 'axios'

import { QueryKeys } from '../../constants'
import { createPermissionsService } from '../../services/permissions'
import { useSessionStore } from '../../stores/session'

export const usePermissionsQuery = (httpClient: AxiosInstance) => {
  const setPermissions = useSessionStore(state => state.setPermissions)
  const accessToken = useSessionStore(state => state.authData.accessToken)

  const permissionsService = useMemo(
    () => createPermissionsService(httpClient),
    [httpClient]
  )

  const query = useQuery({
    queryKey: QueryKeys.permissions(accessToken),
    enabled: !!accessToken,
    retry: false,
    queryFn: async () => {
      const data = await permissionsService.getPermissions()

      setPermissions(data)

      return data
    }
  })

  return {
    ...query
  }
}
